"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyLite = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const styles_1 = require("../../styles");
const context_1 = require("../../styles/context");
const keyClass = (0, nano_theme_1.drule)({
    ...styles_1.fonts.get('mono'),
    bdrad: '4px',
    pd: '0 3px',
    fz: '12.1px',
    lh: '1.2em',
    bxz: 'border-box',
    pe: 'none',
});
const keySmallClass = (0, nano_theme_1.drule)({
    bdrad: '2px',
    lh: '1.1em',
    fz: '10px',
    bxsh: '0 1px 0 0 rgba(0,0,0,0.1)',
});
const KeyLite = ({ small, ...props }) => {
    const styles = (0, context_1.useStyles)();
    const light = styles.light;
    const style = {
        ...props.style,
    };
    if (!light) {
        style.boxShadow = `0 0 0 1px ${styles.g(0.1, 0.16)}`;
    }
    return (React.createElement("kbd", { ...props, className: keyClass({
            bd: '1px solid ' + styles.g(0.8, 0.4),
            bg: styles.col.g('bg-1'),
            col: styles.g(0.2),
        }) +
            (small ? ' ' + keySmallClass() : '') +
            (props.className ? ' ' + props.className : ''), style: style }));
};
exports.KeyLite = KeyLite;
